export default {
  title: 'TRANSPORTATION TIMEOUT SETTINGS',
  items: {
    DriverResponseTime: {
      label: 'Driver Response Time',
      type: 'integer',
      unit: 'seconds'
    },
    CustomerResponseTime: {
      label: 'Customer Response Time',
      type: 'integer',
      unit: 'seconds'
    },
    CarInactiveTimeout: {
      label: 'Car Inactive Timeout',
      type: 'integer',
      unit: 'hours'
    },
    ServerConnectionTimeout: {
      label: 'Server Connection Timeout',
      type: 'integer',
      unit: 'seconds'
    },
    ChainNoShowTimeout: {
      label: 'Shared No Show Timeout',
      type: 'integer',
      unit: 'seconds'
    },
    ChainRequestTimeout: {
      label: 'Shared Accept Timeout',
      type: 'integer',
      unit: 'seconds'
    },
    ASAPRequestTimeout: {
      label: 'ASAP Request Timeout',
      type: 'integer',
      unit: 'seconds'
    },
    DriverLocationReminder: {
      label: 'Driver Location Reminder',
      type: 'integer',
      unit: 'seconds'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/transportation-timeout-settings.js